import { render } from "./TeacherTypingStudentAssignments.vue?vue&type=template&id=322fd7b0&scoped=true"
import script from "./TeacherTypingStudentAssignments.vue?vue&type=script&lang=js"
export * from "./TeacherTypingStudentAssignments.vue?vue&type=script&lang=js"

import "./TeacherTypingStudentAssignments.vue?vue&type=style&index=0&id=322fd7b0&scoped=true&lang=scss"

import exportComponent from "/voc/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-322fd7b0"]])

export default __exports__